"use client";

import { useGlobal } from "@/app/providers/use-global";
import GroqLink from "@/components/ui/groq-link";
import Icon from "@/components/ui/icon";
import { cn } from "@/lib/utils";
import { useMemo } from "react";
import ModelSelect from "../model-select";
import MobileMenu from "./mobile-menu";

export default function Header({
  errorPage,
}: Readonly<{
  errorPage?: boolean;
}>) {
  const { currentModel, isFullScreenIframe, isUserLoggedIn } = useGlobal();
  const isIframe = useMemo(() => {
    if (globalThis.window) {
      return window.self !== window.top;
    }
    return false;
  }, []);

  return (
    <header
      className={cn(
        isIframe && !isFullScreenIframe && "invisible",
        "px-3 py-4 md:px-6 md:pt-7 md:pb-0 md:mb-6 md:grid md:grid-cols-3 flex items-center group-[.iframe]:flex ",
        !isFullScreenIframe && "group-[.iframe]:pt-[18px]",
      )}
    >
      <div>
        <GroqLink href="https://groq.com" className="group-[.iframe]:hidden">
          <Icon
            className="w-[64px] sm:w-[82px] h-[40px] fill-black dark:fill-white"
            icon="groq-logo"
          />
        </GroqLink>
      </div>
      <h1
        className={cn(
          "text-xl text-primaryaccent text-center hidden md:block group-[.iframe]:hidden",
        )}
      >
        Groq is Fast AI Inference
      </h1>
      <div className="flex items-center h-[36px] ml-auto">
        {!errorPage && isUserLoggedIn && currentModel !== undefined && (
          <ModelSelect
            triggerClassName={cn(
              "md:group-[.iframe]:mr-[158px]",
              isIframe && isFullScreenIframe && "md:mr-[174px]",
            )}
          />
        )}
        <div className="ml-4">
          <MobileMenu />
        </div>
      </div>
    </header>
  );
}
